import { render, staticRenderFns } from "./Writer.vue?vue&type=template&id=33ac30c9&scoped=true"
import script from "./Writer.vue?vue&type=script&lang=js"
export * from "./Writer.vue?vue&type=script&lang=js"
import style0 from "./Writer.vue?vue&type=style&index=0&id=33ac30c9&prod&lang=scss"
import style1 from "./Writer.vue?vue&type=style&index=1&id=33ac30c9&prod&scoped=true&lang=css"
import style2 from "./Writer.vue?vue&type=style&index=2&id=33ac30c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac30c9",
  null
  
)

export default component.exports